module.exports = __webpack_public_path__ + "a7fc9544eaac4881fdae44df8607c7d3.MP3";